import { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { landingRoutes, noMenuPatterns } from "./Routes";

import useScreenSizeClass from "./UseScreenSizeClass";

import LandingLayout from "./Layouts/LandingLayout";
import NoMenuLayout from "./Layouts/NoMenuLayout";
import AuthenticatedLayout from "./Layouts/AuthenticatedLayout";

import AlertModal from "../SharedComponents/GeneralModals/Components/AlertModal";
import PendingContractsGate from "../Contracts/Components/PendingContractsGate";
import { getStoredUser } from "../../Helpers/AuthHelper";

// Company users and candidates must accept their pending contracts before using any page.
// The gate wraps the whole layout, so while it blocks there is no menu or header either.
const CONTRACT_GATED_ROLES = ["Admin", "User"];
// Account pages stay reachable, so nobody is stuck (e.g. changing a password).
const CONTRACT_UNGATED_PREFIXES = ["/login", "/register", "/reset-password", "/change-password", "/confirmation", "/hashlogin"];

export default function AppLayout({ children }) {
  const reduxUser = useSelector((s) => s.auth.user);
  // On a fresh page load Redux is filled from localStorage only while the routes render, which
  // is one render too late for the contract gate around them: read the stored login directly.
  const user = reduxUser?.userRole ? reduxUser : getStoredUser();
  const location = useLocation();
  useScreenSizeClass();
  const [isHamburgerMenuActive, setIsHamburgerMenuActive] = useState(false);
  const screenSizeClass = useSelector((state) => state.appMenu.screenSize);
  const path = location.pathname;
  const isLanding = landingRoutes.includes(path);
  const isNoMenu = noMenuPatterns.some((p) => path.includes(p));
  const isAnon = !user?.userRole;

  let LayoutComponent = Fragment;
  let layoutProps = {};

  if (isLanding) {
    LayoutComponent = LandingLayout;
    layoutProps = {
      isHamburgerMenuActive,
      setIsHamburgerMenuActive,
    };
  } else if (isNoMenu) {
    LayoutComponent = NoMenuLayout;
  } else if (isAnon) {
  } else {
    LayoutComponent = AuthenticatedLayout;
    layoutProps = { screenSizeClass };
  }

  const needsContractGate =
    CONTRACT_GATED_ROLES.includes(user?.userRole) &&
    !isLanding &&
    !CONTRACT_UNGATED_PREFIXES.some((p) => path.toLowerCase().startsWith(p));

  const containerStyle = screenSizeClass === "mobile-screen collapsed" ? { overflowY: "hidden" } : {};

  const page = <LayoutComponent {...layoutProps}>{children}</LayoutComponent>;

  return (
    <div className="position-relative" style={containerStyle}>
      <AlertModal />
      <PendingContractsGate enabled={needsContractGate} user={user}>
        {page}
      </PendingContractsGate>
    </div>
  );
}
